

export enum VisiblePages {
    TABLE = 'table',
    CREATE = 'create',
    TURNO = 'turno'
}